import React, { useEffect, useState } from 'react';
import WhiteCard from '../../../../components/accountCards/WhiteCard';
import { CreateMT5AccountTypeApi, GetAllAccountTypeApi } from '../../../../api/request/account';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin, Form, Select } from 'antd';
import toast from 'react-hot-toast';
import ModalComponent from '../../../../components/modals/ModalComponent.jsx';
import LoadableButton from '../../../../components/buttons/LoadableButton.jsx';
import Copy from '../../../../components/copy/Copy.jsx';

export default function AccountTypes() {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state.user);
    const [searchParams] = useSearchParams();
    const [accountTypes, setAccountTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(false);
    const [createdDemoAccount, setCreatedDemoAccount] = useState(null);
    const [demoInitialValues, setDemoInitialValues] = useState({ depositAmount: null, leverage: null });
    const [isOpenDemoForm, setIsOpenDemoForm] = useState(false);
    const [isOpenDemoAccountSuccess, setIsOpenDemoAccountSuccess] = useState(false);
    const [isDemoFormLoading, setIsDemoFormLoading] = useState(false);
    const [liveInitialValues, setLiveInitialValues] = useState({ leverage: null });
    const [isOpenLiveForm, setIsOpenLiveForm] = useState(false);
    const [isLiveFormLoading, setIsLiveFormLoading] = useState(false);
    const [depositOptions, setDepositOptions] = useState([{ value: 1000, label: '1000' }, { value: 3000, label: '3000' }, { value: 5000, label: '5000' }, { value: 50000, label: '50000' }, { value: 100000, label: '100000' }]);
    const [leverageOptions, setLeverageOptions] = useState([{ value: 20, label: '20' }, { value: 50, label: '50' }, { value: 100, label: '100' }, { value: 200, label: '200' }, { value: 300, label: '300' }, { value: 400, label: '400' }, { value: 500, label: '500' }]);


    const copyText = (text) => {
        navigator.clipboard.writeText(text);
    }

    const getAcounts = async () => {
        try {
            setIsLoading(true);
            let params = {
                UserId: userDetails?._id,
                AccountType: searchParams?.get('type') == 'live' ? true : "demoaccount"
            }
            const { data } = await GetAllAccountTypeApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setAccountTypes(data?.data?.filter((item) => item?.isActive));
            }
            setIsLoading(false);
        } catch (error) { }
    }

    useEffect(() => {
        getAcounts();
    }, []);

    const createAccount = (account) => {
        setSelectedAccount(account);
        if (searchParams?.get('type') == 'live') {
            setIsOpenLiveForm(true);
            return;
        }
        if (searchParams?.get('type') == 'demo') {
            setIsOpenDemoForm(true);
            return;
        }
    }

    const handleDemoAccount = async (values) => {
        try {
            setIsDemoFormLoading(true);
            let params = {
                depositAmount: values?.depositAmount,
                groupId: selectedAccount?.groupId,
                groupName: selectedAccount?.groupName,
                isDemoAccount: true,
                isLiveAccount: false,
                leverage: values?.leverage,
                planId: selectedAccount?.planId,
                userId: userDetails?._id
            }
            const { data } = await CreateMT5AccountTypeApi(params);
            if (data?.success) {
                setCreatedDemoAccount(data?.data);
                setIsDemoFormLoading(false);
                toast?.success(data?.message);
                setIsOpenDemoAccountSuccess(true);
            }
        } catch (error) {
            if (error?.response?.data?.error?.message) {
                toast.error(error?.response?.data?.error?.message);
            }
            setIsDemoFormLoading(false);
        }
    }

    const handleLiveAccount = async (values) => {
        try {
            setIsLiveFormLoading(true);
            let params = {
                depositAmount: 0,
                groupId: selectedAccount?.groupId,
                groupName: selectedAccount?.groupName,
                isDemoAccount: false,
                isLiveAccount: true,
                leverage: values?.leverage,
                planId: selectedAccount?.planId,
                userId: userDetails?._id
            }
            const { data } = await CreateMT5AccountTypeApi(params);
            if (data?.success) {
                setIsLiveFormLoading(false);
                toast?.success(data?.message);
                navigate('/accounts?filter=Live+Account');
            }
        } catch (error) {
            if (error?.response?.data?.error?.message) {
                toast.error(error?.response?.data?.error?.message);
            }
            setIsLiveFormLoading(false);
        }
    }

    const goToDashboard = () => {
        setIsOpenDemoAccountSuccess(false);
        navigate('/dashboard');
    }

    useEffect(() => {
        form.resetFields();
    }, [isOpenDemoForm, isOpenLiveForm]);

    return (
        <div className='min-h-[calc(100vh-145px)]'>
            {isLoading ? (
                <div className="flex justify-center flex-col my-[20%]">
                    <Spin size="large" />
                    <p className="primary text-center mt-2">Loading...</p>
                </div>
            ) : (
                <div className='h-full min-h-[calc(100vh-145px)] flex items-center justify-center'>
                    {
                        accountTypes?.length ? (
                            <div className='flex flex-wrap items-center justify-center gap-5 sm:mx-10'>
                                {accountTypes?.map((account, index) => (
                                    <WhiteCard index={index + 1} account={account} handleSubmit={createAccount} type={searchParams?.get('type')} />
                                ))}
                            </div>
                        ) : (
                            <p className='text-lg text-gray-500'>No accounts found.</p>
                        )
                    }
                </div>
            )}

            {/* Open demo account form modal */}
            <ModalComponent isOpen={isOpenDemoForm} setIsOpen={setIsOpenDemoForm} title='Open Demo Account'>
                <Form className='w-full' autoComplete="off" form={form} initialValues={demoInitialValues} onFinish={handleDemoAccount}>
                    <div className='ant-select-selector-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Deposit</label>
                        <Form.Item name='depositAmount' rules={[{ required: true, message: 'Please select deposit.' }]}>
                            <Select className='border-primary w-full mt-1' placeholder='Select deposit' options={depositOptions} />
                        </Form.Item>
                    </div>
                    <div className='ant-select-selector-white mt-5'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
                        <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
                            <Select className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
                        </Form.Item>
                    </div>
                    <div className='flex justify-center items-center gap-5 mt-10'>
                        <LoadableButton
                            className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                            disabled={isDemoFormLoading}
                            type="Submit"
                            lable='Proceed'
                            isLoading={isDemoFormLoading}
                            loadingLable='Opening Demo Account...'
                        />
                        <button type='button' disabled={isDemoFormLoading} className='bg-red-500 text-sm text-white font-medium uppercase px-8 py-2 rounded-lg hover:bg-red-600 duration-500' onClick={() => setIsOpenDemoForm(false)}>Cancel</button>
                    </div>
                </Form>
            </ModalComponent>

            {/* Demo account success modal */}
            <ModalComponent isOpen={isOpenDemoAccountSuccess} setIsOpen={setIsOpenDemoAccountSuccess} title='Congratulations!, Demo Account Created!'>
                <p className='primary md:text-lg font-semibold'>{userDetails?.fullName} you have Successfully Open MT5 Account with RIM Global.</p>
                <div>
                    <div className='flex justify-between items-center mt-8 border-y py-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Account No.</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.accountNo}</p>
                            <Copy text={createdDemoAccount?.accountNo}></Copy>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Server Name</p></div>
                        <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.serverName}</p>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Master Password</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.master_password}</p>
                            <Copy text={createdDemoAccount?.master_password}></Copy>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Investor Password</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.investor_password}</p>
                            <Copy text={createdDemoAccount?.investor_password}></Copy>
                        </div>
                    </div>
                </div>
                <div className='mt-8 flex justify-center items-center'>
                    <button className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500' onClick={goToDashboard}>Go To Dashboard</button>
                </div>
            </ModalComponent >

            {/* Open live account form modal */}
            <ModalComponent isOpen={isOpenLiveForm} setIsOpen={setIsOpenLiveForm} title='Open Live Account'>
                <Form className='w-full' autoComplete="off" form={form} initialValues={liveInitialValues} onFinish={handleLiveAccount}>
                    <div className='ant-select-selector-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
                        <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
                            <Select className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
                        </Form.Item>
                    </div>
                    <div className='flex justify-center items-center gap-5 mt-10'>
                        <LoadableButton
                            className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                            disabled={isLiveFormLoading}
                            type="Submit"
                            lable='Proceed'
                            isLoading={isLiveFormLoading}
                            loadingLable='Opening Live Account...'
                        />
                        <button type='button' disabled={isLiveFormLoading} className='bg-red-500 text-sm text-white font-medium uppercase px-8 py-2 rounded-lg hover:bg-red-600 duration-500' onClick={() => setIsOpenLiveForm(false)}>Cancel</button>
                    </div>
                </Form>
            </ModalComponent>
        </div >
    )
}
